import { doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from "../../../lib/firebase";
import type { SmartTagAttachmentFile, VCard } from "../../../types/vcard";

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null && !Array.isArray(value);

export const getHelmetMaskWarrantyFiles = (
  formData: Partial<VCard>,
): SmartTagAttachmentFile[] => {
  const categorySpecificInfo = formData.categorySpecificInfo;
  if (!isRecord(categorySpecificInfo)) {
    return [];
  }

  const snowGear = categorySpecificInfo.snowGear;
  if (!isRecord(snowGear)) {
    return [];
  }

  const helmetMask = snowGear.helmetMask;
  if (!isRecord(helmetMask)) {
    return [];
  }

  const attachments = helmetMask.attachments;
  if (!isRecord(attachments)) {
    return [];
  }

  const warranty = attachments.warranty;
  if (!isRecord(warranty) || !Array.isArray(warranty.files)) {
    return [];
  }

  return warranty.files as SmartTagAttachmentFile[];
};

export const withHelmetMaskWarrantyFiles = (
  formData: Partial<VCard>,
  files: SmartTagAttachmentFile[],
): Partial<VCard> => {
  const categorySpecificInfo = isRecord(formData.categorySpecificInfo)
    ? formData.categorySpecificInfo
    : {};
  const snowGear = isRecord(categorySpecificInfo.snowGear)
    ? categorySpecificInfo.snowGear
    : {};
  const helmetMask = isRecord(snowGear.helmetMask) ? snowGear.helmetMask : {};
  const attachments = isRecord(helmetMask.attachments)
    ? helmetMask.attachments
    : {};
  const warranty = isRecord(attachments.warranty) ? attachments.warranty : {};

  return {
    ...formData,
    categorySpecificInfo: {
      ...categorySpecificInfo,
      snowGear: {
        ...snowGear,
        helmetMask: {
          ...helmetMask,
          attachments: {
            ...attachments,
            warranty: {
              ...warranty,
              files,
            },
          },
        },
      },
    },
  };
};

export const persistHelmetMaskWarrantyFiles = async (
  userId: string,
  files: SmartTagAttachmentFile[],
): Promise<void> => {
  const vcardRef = doc(
    db,
    `users/${userId}/vcards/active`,
    "snowGear_helmetMask",
  );
  await updateDoc(vcardRef, {
    "categorySpecificInfo.snowGear.helmetMask.attachments.warranty.files":
      files,
    updatedAt: serverTimestamp(),
  });
};
